const models = require('./models')

var _parent = {};

var vendorApi = null;

const pluginList = ["CDK"];

const log = false;

var DealerManagementAPIHelpers = {
  init: (p) => (_parent = p),

  //TODO: optimize setup so that if a plugin is called multiple times, it only needs to be initialized once (to avoid getting auth token multiple times)

  /** Sets the service plugin to match the customer's DMS
   * @param {Object} config - JSON containing name of customer's DMS
   */
  setup: (config) => {
    if (!config) throw Error(`Missing config object`);
    if (!config.dms) throw Error(`Config missing dms object`);
    if (!config.dms.service) throw Error(`Missing service`);
    if (!pluginList.includes(config.dms.service)) throw Error(`Invalid service`);

    if (config.dms.service === "CDK") {
      log && console.log('setup cdk')
      cdkPlugin = require("./plugins/cdk");
      const cdk = new cdkPlugin
      // await cdk.init()
      vendorApi = cdk
      log && console.log("We setup our vendor API: ", vendorApi);
    }
  },

  /** Fetch repair order object from Fortellis
   * @param {Object} config - JSON for accessing DMS API
   * @param {String} repairOrderId - User provided repair order number from frontend
   * @return {Object} Standardized reponse JSON of Repair Order data
   */
  async getRepairOrder(config, repairOrderId) {
    try {
      if (!config) throw new Error(`Missing config object`);
      if (!repairOrderId) throw new Error(`Missing repair order id`);
      this.setup(config)
      let response = await vendorApi.getRepairOrder(config, repairOrderId);
      log && console.log("get RepairOrder response", response);
      return response;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  /** Fetch vehicle object from Fortellis
   * @param {Object} config - JSON for accessing DMS API
   * @param {Int} vehicleOrderId - Fortellis internal id number for vehicle
   * @return {Object} Object containing vehicle info to store in SAT moves table
   */
  async getVehicle(config, vehicleId) {
    try {
      if (!config) throw new Error(`Missing config object`);
      if (!vehicleId) throw new Error(`Missing repair order id`);
      this.setup(config);
      let response = await vendorApi.getVehicle(config, vehicleId);
      log && console.log("get getVehicle response", response);
      return response;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  /** Fetch consumer object from Fortellis
   * @param {Object} config - JSON for accessing DMS API
   * @param {Int} customerId - Fortellis internal id number for customer
   * @return {Object} Object containing consumer info
   */
  async getConsumer(config, customerId) {
    try {
      if (!config) throw new Error(`Missing config object`);
      if (!customerId) throw new Error(`Missing repair order id`);
      this.setup(config);
      let response = await vendorApi.getCustomer(config, customerId);
      log && console.log("get getCustomer response", response);
      return response;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
};
module.exports = DealerManagementAPIHelpers;
